import './scss/main.scss'

import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import { createPinia } from 'pinia'
import { useMiscStore } from './stores/misc-store'

const app = createApp(App)

// 1️⃣ Create Pinia instance
const pinia = createPinia()
app.use(pinia)

// 2️⃣ Access store *after* Pinia is installed
const miscStore = useMiscStore(pinia)

// 3️⃣ Set the global i18n locale to the stored language
i18n.global.locale.value = miscStore.currentLang

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
